<div class="w-full h-full flex flex-col gap-2 overflow-y-auto">
    <div class="w-full flex flex-col items-center justify-center gap-2">
        <h2 class="w-full oswald-font text-2xl">
            Witness Interview
        </h2>
        <!-- <p class="w-full">
            For use when interviewing staff members who witnessed or have direct knowledge about the threatening situation, and/or who have specific knowledge regarding the student or the threatening situation being reviewed. These questions provide a foundation for the interview, but may be modified or expanded as necessary depending on the circumstances.
        </p> -->
    </div>

    <div class="h-full w-full overflow-y-auto flex flex-col items-start justify-start gap-4">
        <ol class="flex h-14 shrink-0 items-center w-full">
            <li *ngFor="let step of stepsConfig" class="flex w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-100 after:border-4 after:inline-block">
                <button 
                    [attr.data-tooltip-target]="step.completionProperty" data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                    [ngClass]="{
                        'bg-nside-orange-400': currentStep === step.id,
                        'bg-orange-100': currentStep !== step.id && currentWintessInterview?.[step.completionProperty] === 1,
                        'bg-gray-100': currentStep !== step.id && currentWintessInterview?.[step.completionProperty] !== 1,
                        'cursor-not-allowed': step.nextStepDependency && currentWintessInterview?.[step.nextStepDependency] !== 1
                    }"
                    (click)="goToStep(step.id)"
                    [disabled]="step.nextStepDependency && currentWintessInterview?.[step.nextStepDependency] !== 1"
                >
                    <lucide-icon [img]="icons.FileUser" [ngClass]="{
                        'text-white': currentStep === step.id,
                        'text-nside-orange-400': currentStep !== step.id && currentWintessInterview?.[step.completionProperty] === 1,
                        'text-gray-text': currentStep !== step.id && currentWintessInterview?.[step.completionProperty] !== 1
                    }"></lucide-icon>
                </button>
                <div [id]="step.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    {{ tooltips[step.id-1]}}
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </li>
            <li class="flex items-center">
                <button 
                    [attr.data-tooltip-target]="finalStepConfig.completionProperty" data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                    [ngClass]="{
                        'bg-nside-orange-400': currentStep === finalStepConfig.id,
                        'bg-orange-100': currentStep !== finalStepConfig.id && currentWintessInterview?.[finalStepConfig.completionProperty] === 1,
                        'bg-gray-100': currentStep !== finalStepConfig.id && currentWintessInterview?.[finalStepConfig.completionProperty] !== 1,
                        'cursor-not-allowed': finalStepConfig.nextStepDependency && currentWintessInterview?.[finalStepConfig.nextStepDependency] !== 1
                    }"
                    (click)="goToStep(finalStepConfig.id)"
                    [disabled]="currentWintessInterview?.[finalStepConfig.nextStepDependency] !== 1"
                >
                    <lucide-icon [img]="icons.FileCheck" [ngClass]="{
                        'text-white': currentStep === finalStepConfig.id,
                        'text-nside-orange-400': currentStep !== finalStepConfig.id && currentWintessInterview?.[finalStepConfig.completionProperty] === 1,
                        'text-gray-text': currentStep !== finalStepConfig.id && currentWintessInterview?.[finalStepConfig.completionProperty] !== 1
                    }"></lucide-icon>
                </button>
                <div [id]="finalStepConfig.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    {{ tooltips[finalStepConfig.id-1]}}
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </li>
        </ol>
        <div class="w-full flex flex-col items-center justify-center overflow-y-auto gap-2">
            <witness-info 
                *ngIf="this.currentStep===1 && this.currentWintessInterview"
                class="w-full h-full overflow-y-auto"
                [witnessInterviewData]="this.currentWintessInterview" 
                (onSaveSection1)="handleUpdateWintessInterview($event, 1)"
            ></witness-info>
            <involvement 
                *ngIf="this.currentStep===2"
                class="w-full h-full overflow-y-auto"
                [witnessInterviewData]="this.currentWintessInterview" 
                (onSaveSection2)="handleUpdateWintessInterview($event, 2)"
            ></involvement>
            <description 
                *ngIf="this.currentStep===3"
                class="w-full h-full overflow-y-auto"
                [witnessInterviewData]="this.currentWintessInterview" 
                (onSaveSection3)="handleUpdateWintessInterview($event, 3)"
            ></description>
            <impressions 
                *ngIf="this.currentStep===4"
                class="w-full h-full overflow-y-auto"
                [witnessInterviewData]="this.currentWintessInterview" 
                (onSaveSection4)="handleUpdateWintessInterview($event, 4)"
            ></impressions>
            <witness-summary 
                *ngIf="this.currentStep===5"
                class="w-full h-full overflow-y-auto"
                [witnessInterviewData]="this.currentWintessInterview" 
                (onSaveSection5)="handleUpdateWintessInterview($event, 5)"
            ></witness-summary>
            <witness-interview-submission 
                *ngIf="this.currentStep===6"
                class="w-full h-full overflow-y-auto"
                [witnessInterviewData]="this.currentWintessInterview" 
                (onSaveSection6)="handleUpdateWintessInterview($event, 6)"
            ></witness-interview-submission>
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    (close)="resetMessageModal()"
    [message]="popupMessage"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>